import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { OrdersOverdue } from '../types/OrderOverdues'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'

type OrderClientOverdue = PaginatedParams & {
  customerId: string
}

const loadOrderClientOverduePayments = (
  data: OrderClientOverdue
): PaginatedResponse<OrdersOverdue> => {
  const { page = 1, limit = 10 } = data
  return axios.get(`/orders/customers/${data.customerId}/overdue-payments`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderClientOverduePayments(query: OrderClientOverdue) {
  return useQuery(
    ['orderClientOverdue', query],
    () => loadOrderClientOverduePayments(query),
    {
      enabled: !!query.customerId,
      onError: () =>
        toast.error('Não foi possível carregar títulos vencidos!', {
          toastId: 'loadOrderOverdue'
        })
    }
  )
}
